import { Tiers } from '@aeCore/enums/user-role.enum';

export type UserKycTier = 'T0' | 'T1';

const AVATAR_TIER_BACKGROUNDS: Record<UserKycTier, string> = {
  T1: 'linear-gradient(135deg, #0ea5e9, #2563eb)',
  T0: 'linear-gradient(135deg, #94a3b8, #64748b)',
};

/** Inline background for avatars (bypasses encapsulation / stale CSS issues). */
export function userAvatarBackground(tier: UserKycTier): string {
  return AVATAR_TIER_BACKGROUNDS[tier] ?? AVATAR_TIER_BACKGROUNDS.T0;
}

export interface UserInitialsSource {
  firstName?: string;
  lastName?: string;
  email?: string;
}

/** Matches users table / transactions avatar tier coloring. */
export function userKycTierFromTier(tier?: number | null): UserKycTier {
  return tier === Tiers.TIER_1 ? 'T1' : 'T0';
}

/** Two-letter initials for user avatars (name first, then email local part). */
export function userInitialsFromUser(user: UserInitialsSource): string {
  const first = user.firstName?.trim()?.[0] ?? '';
  const last = user.lastName?.trim()?.[0] ?? '';
  const fromName = `${first}${last}`.toUpperCase();
  if (fromName.length >= 2) return fromName.slice(0, 2);

  const emailLocal = (user.email?.trim().split('@')[0] ?? '').replace(/[^a-zA-Z0-9]/g, '');
  if (fromName.length === 1 && emailLocal.length >= 1) {
    const second =
      emailLocal[0] === fromName.toLowerCase() ? emailLocal[1] : emailLocal[0];
    if (second) return `${fromName}${second}`.toUpperCase().slice(0, 2);
  }

  if (emailLocal.length >= 2) return emailLocal.slice(0, 2).toUpperCase();
  if (emailLocal.length === 1) return emailLocal.toUpperCase();
  return '?';
}
